import React, {Component} from "react";
import {connect} from "react-redux";

import TemplateSmall from "../templates/TemplateSmall";
import * as templateHelper from '../helper/template'
import ErrorBoundary from "../common/ErrorBoundary";
import {fetchDashboards, setFetchParams} from "../../../store/slices/admin/dashboards";
import {ITemplateConfig} from "../../../constants/interfaces";
import Loader from "../Loader";
import { DebouncedFunc, debounce } from "lodash";
import FetchPaginatedData from "../common/FetchPaginatedData";
import Pagination from "../common/Pagination";

type Props = {
    isActive: boolean,
    isEdit?: boolean,
    templateId: number | string,
    selectTemplate: Function,
    switchTab: Function,
    // injected
    dispatch: Function,
}

type State = {
    activeTab: string,
    page: number,
    searchTerm: string
}

class TemplateTab extends Component<Props, State> {
    sendSearchParams: DebouncedFunc<() => void>;

    constructor(props: Props) {
        super(props);

        this.state = {
            activeTab: "empty",
            page: 1,
            searchTerm: ''
        }
        
        this.onSearch = this.onSearch.bind(this);
        this.sendSearchParams = debounce(this._sendSearchParams.bind(this), 600);
        this.changePage = this.changePage.bind(this);
    }

	switchTab(tab: string) {
        this.setState({
            page: 1,
            searchTerm: '',
            activeTab: tab
        });
    }

    onSearch(event: React.FormEvent<HTMLInputElement>) {
        //@ts-ignore
        const searchTerm = event.target.value;

        this.setState({ searchTerm: searchTerm, page: 1 }, () => {
            this.sendSearchParams();
        });
    }

    _sendSearchParams() {
        //@ts-ignore
        this.props.dispatch(fetchDashboards({
            sort: 'description',
            order: 'asc',
            page: 1,
            searchTerm: this.state.searchTerm
        }));
    }

    changePage(page: number) {
        this.setState({ page: page }, () => {
            this.props.dispatch(fetchDashboards({ sort: 'description', order: 'asc', page: this.state.page, searchTerm: this.state.searchTerm }));
        });
    }

    render() {
        const templates = templateHelper.getTemplates();
        return (
            <div className={`template-tab ${this.props.isActive ? "d-block" : "d-none"}`}>
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <span
                            className={`nav-link ${this.state.activeTab === "empty" ? "active" : ""}`}
                            onClick={() => this.switchTab("empty")}
                        >
                            Empty templates
                        </span>
                    </li>
					{
						!this.props.isEdit && (
							<li className="nav-item">
								<span
									className={`nav-link ${this.state.activeTab === "filled" ? "active" : ""}`}
									onClick={() => this.switchTab("filled")}
								>
									Filled templates
								</span>
							</li>
						)
					}
                </ul>
                <ErrorBoundary>
                {
                    this.state.activeTab === "empty" ? (
                        <div className="empty-templates">
                            <div className="row">
                                {
                                    templates.map((template, index) => (
                                        <div className="col-lg-6" key={index}>
                                            <TemplateSmall
                                                isActive={this.props.templateId === template.id}
                                                gridType={template.grid_type_id}
												id={template.id}
                                                selectTemplate={this.props.selectTemplate}
												config={null}
                                                switchTab={this.props.switchTab}
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ) : (
                        <div className="filled-templates">
                            <div className="search">
                                <input type="search" placeholder="Search dashboards" value={this.state.searchTerm} onChange={this.onSearch} className="form-control" />
                            </div>
                            <FetchPaginatedData
                                action={{ function: fetchDashboards, payload: {} }}
                                storeKey="dashboards"
                                alwaysReload={true}
                                render={(dashboards, isLoading, pagination) => (     
                                    <>
                                        <Loader isLoading={isLoading} customClass="templates-loader">
                                            <div className="row">
                                                {
                                                    dashboards && dashboards.length > 0 && dashboards.map((dashboard: any, index: number) => (
                                                        <div className="col-lg-6" key={index}>
                                                            <p>{dashboard.description}</p>
                                                            <TemplateSmall
                                                                isActive={this.props.templateId === dashboard.id}
                                                                gridType={dashboard.grid_type_id}
                                                                id={dashboard.id}
                                                                selectTemplate={this.props.selectTemplate}
                                                                config={dashboard}
                                                                switchTab={this.props.switchTab}
                                                            />
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </Loader>

                                        {!isLoading && pagination?.totalPages > 1 && <Pagination page={this.state.page} total={pagination?.totalPages} setPage={this.changePage} />}
                                    </>
                                )}
                            />
                        </div>
                    )
                }
                </ErrorBoundary>
            </div>
        );
    }
}

export default connect()(TemplateTab);